<iframe class="video-player-external cove-video-player" ></iframe>


import React, { PureComponent } from 'react';

export default class PBSLivestreamPlayer extends PureComponent {
  render() {
    return <iframe
      className="video-player-external"
      src="//player.pbs.org/ga-livestream-partnerplayer/?station_id=3742dff1-85cd-42d1-ab39-7ffa8ef10211"
      frameborder="0"
      scrolling="no"
      allowFullScreen={true}
      allow="geolocation; fullscreen; autoplay; encrypted-media" />;
  }
}